import { Button } from "@aprosoja/ui";

import { useSignUpContext } from "../../../../context/sign-up.context";

type ControlButtonsProps = {
  isLoading?: boolean;
};

const ControlButtons = ({ isLoading }: ControlButtonsProps) => {
  const { signUpReducer, setSignUpReducer } = useSignUpContext();

  return (
    <div className="flex justify-end gap-size-x2">
      {signUpReducer.signUpStep > 0 && (
        <Button
          onClick={() =>
            setSignUpReducer({
              type: "signUpStep",
              signUpStepPayload: signUpReducer.signUpStep - 1,
            })
          }
          variant="outlined"
          className="rounded-border-radius-small"
          disabled={isLoading}
        >
          Voltar
        </Button>
      )}
      <Button
        type="submit"
        className="rounded-border-radius-small min-w-[90px]"
        loading={isLoading}
      >
        {signUpReducer.signUpStep === 2 ? "Pagar" : "Continuar"}
      </Button>
    </div>
  );
};

export default ControlButtons;
